// extracted by mini-css-extract-plugin
export default {"bodyContainer":"body_bodyContainer__irTtM"};